import type { ReactNode } from "react";
import { Box } from "@mui/material";
import { useChatRail } from "./ChatRailProvider";
import { useThemeMode } from "../../../theme/ThemeModeProvider";
import { chatRailTokens } from "../tokens";
import { AgentTabStrip } from "./AgentTabStrip";
import { ConversationTabs } from "./ConversationTabs";
import { ChatThread } from "./ChatThread";
import { Composer } from "./Composer";
import { StarterPromptCards } from "./StarterPromptCards";

export interface ChatRailBodyProps {
  trailingHeader?: ReactNode;
  hideAgentStrip?: boolean;
}

export function ChatRailBody({ trailingHeader, hideAgentStrip = false }: ChatRailBodyProps) {
  const { activeAgentId, activeConvoId } = useChatRail();
  const { mode } = useThemeMode();
  const T = chatRailTokens(mode);

  return (
    <Box sx={{ display: "flex", flexDirection: "row", flex: 1, minHeight: 0 }}>
      {!hideAgentStrip && <AgentTabStrip />}

      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderBottom: `1px solid ${T.hair}`,
            minHeight: T.conversation_tab_height,
            px: 0.5,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
            {activeAgentId && <ConversationTabs />}
          </Box>
          {trailingHeader}
        </Box>

        {activeAgentId && activeConvoId ? (
          <ChatThread agentId={activeAgentId} conversationId={activeConvoId} />
        ) : activeAgentId ? (
          <StarterPromptCards agentId={activeAgentId} />
        ) : (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 3,
            }}
          >
            <Box sx={{ color: T.textMute, fontSize: T.fs_meta }}>No agents available.</Box>
          </Box>
        )}

        {activeAgentId && <Composer agentId={activeAgentId} conversationId={activeConvoId} />}
      </Box>
    </Box>
  );
}
